import { useState } from 'react';

import { useStates } from '@/core/domain/zipcode/States/States.hooks';
import {
  useCitiesByState,
  useCity,
} from '@/core/domain/zipcode/Cities/Cities.hooks';
import { useZipCode } from '@/core/domain/zipcode/ZipCodes/ZipCodes.hooks';

function useAddressQueries(enabled = true) {
  const [selectedZipCode, setSelectedZipCode] = useState<string>();
  const [selectedStateCode, setSelectedStateCode] = useState<string>();
  const [selectedCityId, setSelectedCityId] = useState<number>();

  const statesList = useStates(enabled);
  const citiesByState = useCitiesByState(selectedStateCode, enabled);
  const city = useCity(selectedCityId, enabled);
  const zipCode = useZipCode(selectedZipCode, enabled);

  return {
    state: {
      setSelectedStateCode,
      list: statesList.data?.data || [],
      isFetching: statesList.isFetching,
    },
    city: {
      list: citiesByState.data?.data || [],
      isFetching: citiesByState.isFetching,

      setSelectedCityId,
      selectedCity: city.data,
    },
    zipCode: {
      setSelectedZipCode,
      data: zipCode.data,
      isFetching: zipCode.isFetching,
    },
  };
}

export default useAddressQueries;
